import React from 'react';
import { Input } from '../../components/ui/input';
import { MapPin, Navigation, Loader2, Home as HomeIcon, Briefcase } from 'lucide-react';

const LocationInput = ({
  label,
  placeholder,
  value,
  onChange,
  onFocus,
  onBlur,
  suggestions,
  showSuggestions,
  onSelectSuggestion,
  savedAddresses,
  user,
  onSelectSavedAddress,
  markerColor = 'bg-gray-400',
  showCurrentLocation = false,
  onGetCurrentLocation,
  gettingLocation = false
}) => {
  return (
    <div className="relative">
      <div className="flex items-center gap-3">
        <div className={`w-3 h-3 rounded-full ${markerColor}`}></div>
        <div className="flex-1 relative">
          <Input
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            onFocus={onFocus}
            onBlur={onBlur}
            className="border-gray-300 focus:border-pink-500 focus:ring-pink-500"
          />
          {showSuggestions && value && suggestions.length > 0 && (
            <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-50 max-h-48 overflow-y-auto">
              {suggestions.slice(0, 5).map((loc, idx) => (
                <button
                  key={idx}
                  className="w-full text-left px-4 py-3 hover:bg-gray-50 transition-colors flex items-center gap-2"
                  onMouseDown={() => onSelectSuggestion(loc)}
                >
                  <MapPin className="h-4 w-4 text-gray-400" />
                  <span className="text-sm text-gray-700">{loc}</span>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
      
      {/* Use Current Location Button */}
      {showCurrentLocation && (
        <div className="ml-6 mt-2">
          <button
            onClick={onGetCurrentLocation}
            disabled={gettingLocation}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-green-50 hover:bg-green-100 text-green-700 text-sm rounded-full transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {gettingLocation ? (
              <>
                <Loader2 className="h-3.5 w-3.5 animate-spin" />
                Getting location...
              </>
            ) : (
              <>
                <Navigation className="h-3.5 w-3.5" />
                Use current location
              </>
            )}
          </button>
        </div>
      )}
      
      {/* Saved Address Quick Select */}
      {user && (savedAddresses?.home || savedAddresses?.work || (savedAddresses?.favorites && savedAddresses.favorites.length > 0)) && (
        <div className="ml-6 mt-2 flex flex-wrap gap-2">
          {savedAddresses.home && (
            <button
              onClick={() => onSelectSavedAddress(savedAddresses.home)}
              className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-blue-50 hover:bg-blue-100 text-blue-700 text-sm rounded-full transition-colors"
            >
              <HomeIcon className="h-3.5 w-3.5" />
              Home
            </button>
          )}
          {savedAddresses.work && (
            <button
              onClick={() => onSelectSavedAddress(savedAddresses.work)}
              className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-purple-50 hover:bg-purple-100 text-purple-700 text-sm rounded-full transition-colors"
            >
              <Briefcase className="h-3.5 w-3.5" />
              Work
            </button>
          )}
          {savedAddresses.favorites && savedAddresses.favorites.slice(0, 2).map((fav, idx) => (
            <button
              key={idx}
              onClick={() => onSelectSavedAddress(fav.address)}
              className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-pink-50 hover:bg-pink-100 text-pink-700 text-sm rounded-full transition-colors"
            >
              <MapPin className="h-3.5 w-3.5" />
              {fav.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LocationInput;
